module.exports = __webpack_public_path__ + "img/34.44e9b6ab.png";